import { MutableRefObject, RefObject, UIEvent } from 'react'

import { useMultipleRect, useRect } from '@/common/util/rect'
import { useScrollHorizon, useWindowScrolledTo } from '@/common/util/scroll'

import { FLOAT_HEIGHT } from '@/components/view/layouts/float/BottomFloat'
import { HEADER_HEIGHT } from '@/components/view/molecules/header/Header'

const DEFAULT_LIST_WIDTH = 1024

export interface ListFollowTableHeaderFloatProps {
  headFloatRef: MutableRefObject<any>
  width: number
  isScrolledToTable: boolean
}

export interface ListFollowTableHeaderProps {
  rowRefs: RefObject<HTMLTableCellElement>[]
  rowRects: (DOMRect | null)[]
  isScrolled: boolean
}

export interface ListFollowTableProps {
  tableRef: MutableRefObject<any>
  onScrollTable(event: UIEvent<HTMLElement>): void
}

export interface ListFollowProps {
  tableRect: DOMRect | null
  floatButtonFixed: boolean
  onScrollBar(event: UIEvent<HTMLElement>): void
  barRef: RefObject<any>
  headerFloat: ListFollowTableHeaderFloatProps
  header: ListFollowTableHeaderProps
  table: ListFollowTableProps
}

export const useListScrollFollow = (columnLength: number, additionalHeaderHeight: number = 0): ListFollowProps => {
  const [tableRef, tableRect] = useRect()
  const {
    isScrolled: isScrolledToTable,
    isScrolledStart: floatButtonFixed,
    isScrolledEnd
  } = useWindowScrolledTo(tableRef, HEADER_HEIGHT - additionalHeaderHeight, FLOAT_HEIGHT)

  const [rowRefs, rowRects] = useMultipleRect<HTMLTableCellElement>(columnLength)
  const { onScrollTable, onScrollBar, headFloatRef, barRef, isScrolled } = useScrollHorizon(tableRef)

  const width = tableRect ? tableRect?.width : DEFAULT_LIST_WIDTH

  return {
    tableRect,
    floatButtonFixed: floatButtonFixed && !isScrolledEnd,
    onScrollBar,
    barRef,
    headerFloat: {
      headFloatRef,
      width,
      isScrolledToTable
    },
    header: {
      rowRefs,
      rowRects,
      isScrolled
    },
    table: {
      tableRef,
      onScrollTable
    }
  }
}

export const makeRectPropsForTableHeadItem = (
  rowRefs: RefObject<HTMLTableCellElement>[],
  rowRects: (DOMRect | null)[],
  index: number,
  float: boolean
) => ({
  ref: rowRefs && !float ? rowRefs[index] : undefined,
  minWidth: rowRects && float ? rowRects[index]?.width : undefined,
  width: rowRects && float ? rowRects[index]?.width : undefined
})
